import { render, staticRenderFns } from "./ContabilitaDocumentiListPage.vue?vue&type=template&id=b2925228"
import script from "./ContabilitaDocumentiListPage.vue?vue&type=script&lang=js"
export * from "./ContabilitaDocumentiListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports